export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/check-circle-dealer.dfb11c6a.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};